import { Box, Link } from '@mui/material';
import '../../stylesheets/welcome_prechat.css'
import Back from './Reusable/Back';
import { useEffect, useRef, useState } from 'react';
import SignIn from './SignIn';
import SignUp from './SignUp';
import PrimaryButton from './Mui/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { isDarkMode, themeColors, appleRedirectUrl } from "../utils/constants";
import GoogleIcon from '../../javascript/images/GoogleIcon.png'
import AppleIconDark from '../../javascript/images/AppleIcon.png'
import AppleIcon from '../../javascript/images/AppleIconDark.png'
import MailIcon from '../../javascript/images/MailIcon.png'
import { GoogleLogin } from '@react-oauth/google';
import AppleLogin from 'react-apple-login';
import PrintOutText from "./Chat/PrintOutText";
import { trackBackendEvents, trackFrontendEvent } from "../utils/tracking";
import { trackConversionGateEvent } from "../utils/conversionGateTracking";
import {
  clearPendingSecondQuestion,
  readPendingSecondQuestion,
} from "../utils/signup_modal";
import { primaryAppPath } from "../utils/appNavigation";
import {
  forgotPasswordPathFor,
  navigateToPostAuthPath,
} from "../utils/auth_navigation";
import { checkoutIntentFromPath } from "../utils/offer_intent";
import OfferIntentCard from "./AuthFlow/OfferIntentCard";
import { desktopClientMetadata } from "../utils/desktopApp";
import {
  BROWSER_SIGN_IN_ERRORS,
  canUseDesktopBrowserSignIn,
  completeDesktopBrowserSignIn,
  startDesktopBrowserSignIn,
} from "../utils/desktopBrowserSignIn";

// Heading and reassurance shown above sign-in/sign-up when someone arrives
// from an offer link or a plan's checkout button.
const RegisterOfferIntent = ({ intent, signInOrUp }) => {
  if (!intent) return null;

  const signingIn = signInOrUp === 'sign-in';
  const heading = intent.offer
    ? (signingIn ? 'Sign in to claim your offer' : 'Create your account to claim your offer')
    : (signingIn ? 'Sign in to continue to checkout' : 'Create your account to continue to checkout');

  return (
    <div className="auth-flow-tokens auth-flow-register-offer" data-register-offer-intent>
      <h2 className="auth-flow-register-offer__heading">{heading}</h2>
      <OfferIntentCard
        intent={intent}
        compact
        status={`Your ${intent.offer ? 'offer' : 'plan'} will be waiting after you ${signingIn ? 'sign in' : 'sign up'}.`}
      />
    </div>
  )
}

const NewAccountPage = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const {
    appProps,
    signInOrUp,
    setSignInOrUp,
    signInType, setSignInType,
    successRedirectPath,
  } = props

  const {
    registerNavMessage, 
    setRegisterNavMessage, userData, setUserData,
    setShowPaywallModal,
    showPaywallAfter,
  } = appProps

  const [goToChat, setGoToChat] = useState(false)
  const checkoutIntent = checkoutIntentFromPath(successRedirectPath)
  const [signInEmail, setSignInEmail] = useState(location.state?.email || '')
  const scrollRef = useRef(null)

  // Switching between sign in and sign up starts at the top, where the offer is.
  useEffect(() => {
    scrollRef.current?.scrollTo?.({ top: 0 })
  }, [signInType])
  const [errors, setErrors] = useState([])
  const [ messageText, setMessageText ] = useState("")


  const setErrorsArray = (e) => {
    if (!e) return setErrors([]);
    if (Array.isArray(e)) return setErrors(e.filter(Boolean));
    if (typeof e === 'string') return setErrors([e]);
    if (e.message) return setErrors([e.message]);
    // last resort
    return setErrors([String(e)]);
  };

  useEffect(() => {
    if (registerNavMessage) {
      setTimeout(() => {
        const characters = registerNavMessage.split('')
        let curStr = ''
        characters.forEach((char, index) => {
          setTimeout(() => {
            curStr = curStr.concat(char)
            setMessageText(curStr);
          }, index * 50);
        })
      }, 100)
    }
  }, [registerNavMessage])

  useEffect(() => {
    if (goToChat) {
      // Show the paywall again!
      // if (showPaywallAfter) {
      //   setShowPaywallModal(true)
      // }
      navigate(primaryAppPath())
    }
  }, [goToChat, navigate])

  useEffect(() => {
    // If they are logged in, redirect back to chat from register
    if (userData.user_id) {
      navigateToPostAuthPath(navigate, successRedirectPath)
    }
  }, [navigate, successRedirectPath, userData])

  return (
    <Box sx={{height: '100vh',}}>
    {/* { signInOrUp == "sign-in" && */}
      <Back value={false}/>
    {/* } */}
    <Box ref={scrollRef} sx={{
      height: '100%',
      overflowY: 'auto',
      backgroundColor: themeColors.backgroundColor,
      }}>
      <Box className="welcome-container" sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
        <Box sx={{color: 'rgb(255,0,0,.6)'}}>
          <ul>
            {(Array.isArray(errors) ? errors : errors ? [errors] : []).map((error, i) => (
              <li key={i}>{String(error)}</li>
            ))}
          </ul>
        </Box>

        <RegisterOfferIntent intent={checkoutIntent} signInOrUp={signInOrUp} />

        { registerNavMessage &&
        <Box sx={{height: '110px', margin: '0px'}}>
        <PrintOutText showDownArrowIcon={false} message={messageText} lineSpacing={[303, 250, 114]}/>
        </Box>
        }

        { signInType == "sign-in-email" &&
        <>
          <SignInApple userData={userData} setUserData={setUserData} setErrors={setErrorsArray} successRedirectPath={successRedirectPath}/>
          <SignInGoogle userData={userData} setUserData={setUserData} setErrors={setErrorsArray} successRedirectPath={successRedirectPath}/>
          <Box className="base-text register-message" sx={{display: 'flex', color: 'gray', marginBottom: '10px', marginTop: '20px',}}>
            <Box style={{width: '100px', margin: 'auto 0px', borderBottom: '1px solid gray'}}/> <Box sx={{margin: 'auto 10px'}}>or </Box> <Box style={{width: '100px', margin: 'auto 0px', borderBottom: '1px solid gray'}}/>
          </Box>
          <SignIn
            appProps={appProps}
            setGoToChat={setGoToChat}
            successRedirectPath={successRedirectPath}
            initialEmail={location.state?.email}
            onEmailChange={setSignInEmail}
          />
        </>
        }
        { signInType == "sign-up-email" &&
        <>
          <SignInApple userData={userData} setUserData={setUserData} setErrors={setErrorsArray} successRedirectPath={successRedirectPath}/>
          <SignInGoogle userData={userData} setUserData={setUserData} setErrors={setErrorsArray} successRedirectPath={successRedirectPath}/>
          <Box className="base-text register-message" sx={{display: 'flex', color: 'gray', marginBottom: '10px', marginTop: '20px',}}>
            <Box style={{width: '100px', margin: 'auto 0px', borderBottom: '1px solid gray'}}/> <Box sx={{margin: 'auto 10px'}}>or </Box> <Box style={{width: '100px', margin: 'auto 0px', borderBottom: '1px solid gray'}}/>
          </Box>
          <SignUp
            appProps={appProps}
            setGoToChat={setGoToChat}
            successRedirectPath={successRedirectPath}
            returnTo={successRedirectPath}
            onSignIn={() => {
              setSignInOrUp('sign-in')
              setSignInType('sign-in-email')
              setRegisterNavMessage()
            }}
          />

        </>
        }

        { signInOrUp == "sign-in"  &&
          <Box sx={{
            width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            color: themeColors.color, marginTop: '30px',
            }}>
            <Box sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              }}>
              {/* <Box sx={{
                  marginTop: '15px',
                  fontSize: '12px'
                }}
                className="base-text sign-text"
              >
                <Link 
                  sx={{'&:hover': {cursor: 'pointer'}, color: themeColors.linkColor, fontSize: '16px'}} 
                  onClick={() => {
                    setSignInOrUp('sign-up')
                    setSignInType("sign-up-email")
                    setRegisterNavMessage()
                  }}
                >Create an account
                </Link>

              </Box> */}
              <Box className="base-text" sx={{fontSize: '14px', marginTop: '10px', color: themeColors.color}}>
                  Don't have an account? <Link 
                    sx={{'&:hover': {cursor: 'pointer'}, color: themeColors.linkColor, fontSize: '16px'}} 
                    onClick={() => {
                      setSignInOrUp('sign-up')
                    setSignInType("sign-up-email")
                    setRegisterNavMessage()
                    }}
                  >Create Account
                  </Link>
                </Box>
              <Box sx={{
                  marginTop: '25px',
                  // fontSize: '12px',
                  color: themeColors.color,
                  fontSize: '14px',
                }}
                className="base-text"
              >
                Forgot your password? <Link 
                  sx={{'&:hover': {cursor: 'pointer'}, color: themeColors.linkColor, fontSize: '16px'}} 
                  onClick={() => {
                    navigate(forgotPasswordPathFor(successRedirectPath), { state: { email: signInEmail } })
                  }}
                >Reset
                </Link>
              </Box>
              
            </Box>
          </Box>
        }
        <Box sx={{height: '150px'}}/>
      </Box>
    </Box>
    </Box>
  )
}

// The response of /google_create_account or /apple_create_account, from the
// web buttons and the desktop app's browser sign-in alike.
export const handleFederatedSignInResponse = (data, {
  provider,
  userData,
  setUserData,
  setShowSignUpModal,
  setErrors,
  trackingMetadata = {},
  navigate,
  successRedirectPath,
}) => {
  if (data.error_message) {
    setErrors(data.error_message)
    return
  }
  const { tracking_events: trackingEvents = [], ...userPayload } = data;
  setUserData({...userData, ...userPayload, requireSignIn: false})
  if (setShowSignUpModal) {
    setShowSignUpModal(false)
  }
  trackBackendEvents(trackingEvents);
  const signupCompletedMetadata = {
    ...trackingMetadata,
    provider,
  };
  trackFrontendEvent("signup_completed", signupCompletedMetadata);
  trackConversionGateEvent("signup_completed", signupCompletedMetadata);
  if (data.queued_pending_signup_question) {
    clearPendingSecondQuestion();
  }
  navigateToPostAuthPath(navigate, successRedirectPath)
}

export const SignInGoogle = (props) => {
  const {
    setErrors,
    userData,
    setUserData,
    onChatPage,
    setShowSignUpModal,
    overrideDarkMode,
    successRedirectPath,
    onProviderClick,
    trackingMetadata = {},
  } = props
  const navigate = useNavigate()
  const [ googleUser, setGoogleUser ] = useState(null);
  const desktopSignIn = canUseDesktopBrowserSignIn();
  const handleResponse = (data, extraTrackingMetadata = {}) => handleFederatedSignInResponse(data, {
    provider: "google",
    userData,
    setUserData,
    setShowSignUpModal,
    setErrors,
    trackingMetadata: { ...trackingMetadata, ...extraTrackingMetadata },
    navigate,
    successRedirectPath,
  });

  useEffect(() => {
    if (googleUser) {
      let user = {
        verified_email: true, // defaulting true for google
        subscribed_marketing: true,
      }
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id_token:  googleUser.credential,
          user: user,
          pending_signup_question: readPendingSecondQuestion(),
        })
      };
      fetch('/google_create_account', requestOptions)
        .then(response => {
          return (response.json())
        })
        .then(data => handleResponse(data))
        .catch(error => {
          console.log('api errors:', error)
          setErrors(error?.message || error)
        })
    }

  }, [googleUser]);

  // Google refuses its sign-in inside the desktop app's window, so the app
  // signs in through the user's browser instead.
  if (desktopSignIn) {
    return (
      <DesktopBrowserSignInButton
        provider="google"
        providerName="Google"
        icon={GoogleIcon}
        overrideDarkMode={overrideDarkMode}
        onProviderClick={onProviderClick}
        setErrors={setErrors}
        onResponse={handleResponse}
      />
    )
  }

  // https://livefiredev.com/in-depth-guide-sign-in-with-google-in-a-react-js-application/
  return (
    // the "colorScheme white" what needed to make it exactly white!
    <Box
      onPointerDownCapture={() => onProviderClick?.("google")}
      sx={{marginTop: '12px', colorScheme: 'light'}}
    >
    <GoogleLogin
      onSuccess={credentialResponse => {
        setGoogleUser(credentialResponse)
      }}
      onError={() => {
        console.log('Login Failed');
      }}
      size="large"
      width="240"
      theme={(overrideDarkMode || isDarkMode) ? "outline" : "filled_black"}
      text="continue_with"
      shape="circle"
    />
    </Box>
  )
}

export const SignInApple = (props) => {
  const {
    setErrors,
    userData,
    setUserData,
    onChatPage,
    setShowSignUpModal,
    overrideDarkMode,
    successRedirectPath,
    onProviderClick,
    trackingMetadata = {},
  } = props
  const navigate = useNavigate()
  const desktopSignIn = canUseDesktopBrowserSignIn();
  const handleResponse = (data, extraTrackingMetadata = {}) => handleFederatedSignInResponse(data, {
    provider: "apple",
    userData,
    setUserData,
    setShowSignUpModal,
    setErrors,
    trackingMetadata: { ...trackingMetadata, ...extraTrackingMetadata },
    navigate,
    successRedirectPath,
  });

  const appleResp = (response) => {
    if (!response.error) {
      // Note that response returns "code" as well which is needed to verify for Apple services etc on behalf of user.
      let user = {
        verified_email: true, // defaulting true for apple
        subscribed_marketing: true,
      }
      if (response.user) {
        user = {
          ...user,
          email: response.user.email,
          first_name: response.user.name.firstName,
          last_name: response.user.name.lastName,
        }
      }
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user: user,
          id_token: response.authorization.id_token,
          pending_signup_question: readPendingSecondQuestion(),
        })
      };
      
      fetch('/apple_create_account', requestOptions)
      .then(response => {
        return (response.json())
      })
      .then(data => handleResponse(data))
      .catch(error => {
        console.log('api errors:', error)
        setErrors(error?.message || error)
      })
    }
  }

  if (desktopSignIn) {
    return (
      <DesktopBrowserSignInButton
        provider="apple"
        providerName="Apple"
        icon={(overrideDarkMode || isDarkMode) ? AppleIconDark : AppleIcon}
        overrideDarkMode={overrideDarkMode}
        onProviderClick={onProviderClick}
        setErrors={setErrors}
        onResponse={handleResponse}
      />
    )
  }

  return (
    <AppleLogin
    clientId="com.inciteai.webapp.signin"
    redirectURI={appleRedirectUrl}
    usePopup={true}
    callback={appleResp}
    scope="email name"
    responseMode="query"
    render={renderProps => (
      <SignInUpLayout 
        text={"Continue with Apple"}
        icon={(overrideDarkMode || isDarkMode) ? AppleIconDark : AppleIcon}
        signType={"sign-in-apple"}
        onClickAction={renderProps.onClick}
        onProviderClick={() => onProviderClick?.("apple")}
        textStyles={{marginRight: '8px', color: (overrideDarkMode || isDarkMode) ? 'rgba(46,49,52,1.0)' : 'rgba(227,229,232,1.0)', fontSize: '13px'}}
        overrideDarkMode={overrideDarkMode}
      />
    )}
  />
  )
}

export const SignInUpEmail = (props) => {
  const { overrideDarkMode, onProviderClick } = props
  const navigate = useNavigate()
  const onClick = () => {
    navigate('/register')
  }
  return (
    <SignInUpLayout 
      text={"Continue with Email"}
      icon={MailIcon}
      signType={"sign-in-email"}
      onClickAction={onClick}
      onProviderClick={() => onProviderClick?.("email")}
      textStyles={{marginRight: '11px', color: (overrideDarkMode || isDarkMode) ? 'rgba(46,49,52,1.0)' : 'rgba(227,229,232,1.0)', fontSize: '13px'}}
      overrideDarkMode={overrideDarkMode}
    />
  )
}

const DESKTOP_SIGN_IN_MESSAGES = {
  [BROWSER_SIGN_IN_ERRORS.EXPIRED]: "Your sign-in expired. Please try again.",
  [BROWSER_SIGN_IN_ERRORS.UNAVAILABLE]: "Signing in through your browser isn't available. Update the Incite app, or continue with email.",
  [BROWSER_SIGN_IN_ERRORS.FAILED]: "We couldn't open your browser to sign in. Please try again.",
};
const DESKTOP_SIGN_IN_NETWORK_MESSAGE = "We couldn't reach Incite. Check your connection, then try again.";

// Desktop app only: opens the user's browser for Google/Apple sign-in, waits
// for the app to receive the result, then completes sign-in here.
export const DesktopBrowserSignInButton = ({
  provider,
  providerName,
  icon,
  overrideDarkMode,
  onProviderClick,
  setErrors,
  onResponse,
}) => {
  const [phase, setPhase] = useState("idle"); // idle | waiting | completing
  const attemptRef = useRef(null);
  const dark = Boolean(overrideDarkMode || isDarkMode);

  // Leaving the screen ends a sign-in that hasn't come back yet.
  useEffect(() => () => attemptRef.current?.cancel(), []);

  const begin = async () => {
    attemptRef.current?.cancel();
    const attempt = startDesktopBrowserSignIn(provider);
    attemptRef.current = attempt;
    setErrors?.([]);
    setPhase("waiting");
    try {
      const { desktopCode, codeVerifier } = await attempt.result;
      setPhase("completing");
      const data = await completeDesktopBrowserSignIn({
        provider,
        desktopCode,
        codeVerifier,
        pendingSignupQuestion: readPendingSecondQuestion(),
      });
      setPhase("idle");
      onResponse(data, desktopClientMetadata());
    } catch (error) {
      if (attemptRef.current !== attempt) return; // replaced by a newer attempt
      setPhase("idle");
      // Cancelling, or starting a sign-in with the other provider, needs no message.
      const message = error?.code ? DESKTOP_SIGN_IN_MESSAGES[error.code] : DESKTOP_SIGN_IN_NETWORK_MESSAGE;
      if (message) setErrors?.([message]);
    }
  };

  if (phase === "idle") {
    return (
      <SignInUpLayout
        text={`Continue with ${providerName}`}
        icon={icon}
        signType={`sign-in-${provider}`}
        onClickAction={begin}
        onProviderClick={() => onProviderClick?.(provider)}
        textStyles={{marginRight: '8px', color: dark ? 'rgba(46,49,52,1.0)' : 'rgba(227,229,232,1.0)', fontSize: '13px'}}
        overrideDarkMode={overrideDarkMode}
      />
    )
  }

  const textColor = dark ? 'rgba(227,229,232,1.0)' : 'rgba(46,49,52,1.0)';
  const linkSx = {
    color: textColor,
    fontSize: '12px',
    textDecorationColor: dark ? 'rgba(227,229,232,0.5)' : 'rgba(46,49,52,0.5)',
    cursor: 'pointer',
  };
  return (
    <Box
      role="status"
      aria-live="polite"
      data-desktop-sign-in-status={phase}
      sx={{
        width: '240px',
        maxWidth: '86%',
        marginTop: '14px',
        padding: '10px 14px',
        borderRadius: '20px',
        border: `1px solid ${dark ? 'rgba(227,229,232,0.25)' : 'rgba(46,49,52,0.2)'}`,
        textAlign: 'center',
        color: textColor,
      }}
    >
      <Box className="base-text" sx={{fontSize: '13px', fontWeight: 500, color: textColor}}>
        {phase === "completing" ? "Signing you in…" : `Sign in with ${providerName} in your browser`}
      </Box>
      {phase === "waiting" && (
        <Box sx={{display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '6px'}}>
          <Link component="button" type="button" onClick={begin} sx={linkSx}>{"Didn't open? Try again"}</Link>
          <Link component="button" type="button" onClick={() => attemptRef.current?.cancel()} sx={linkSx}>Cancel</Link>
        </Box>
      )}
    </Box>
  )
}

const SignInUpLayout = (props) => {
  const { text, icon, sx, textStyles, onClickAction, onProviderClick, overrideDarkMode } = props

  return (
    <Box sx={{width: '240px',maxWidth: '86%', height: '40px', marginTop: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx}}>
      <PrimaryButton
        overrideDarkMode={overrideDarkMode}
        onClick={() => {
          onProviderClick?.();
          onClickAction();
        }}
      >
        <Box sx={{width: '100%', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        }}>
          <Box className="sign-in-icons">
            <img src={icon} style={{maxHeight: '100%', maxWidth: '100%'}}/> 
          </Box>
          <Box className="base-text sign-text" sx={{
            color: '#fff', marginRight: '12px',
          }}
          >
            <Box sx={{display: 'flex'}}>
              <Box sx={{...textStyles, fontWeight: '500'}}>{text}</Box>
            </Box>
          </Box>
        </Box>
      </PrimaryButton>
    </Box>
  )
}

export default NewAccountPage
